import { MouseEvent, useState } from 'react';

import EditSteps from './EditSteps';
import Copy from './copyTarget';
import Delete from './deleteTarget';
import Edit from './EditTarget';
import Hold from './holdTarget';
import MasterOut from './masterOutTarget';
import Move from './moveTarget';
import OpenTarget from './openTarget';
import { TargetProperties, TargetTypes } from '../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';
import GraphsTarget from './TargetGraph/graphsTarget';
import { Badge, Text } from '../../../../../../shared/uiComponents';
import { BadgeTypes } from '../../../../../../shared/uiComponents/StatusBadge';
import { targetStatusType } from '../targetRow';
import { InfoSvg } from '../../../../../../shared/Assets/svgIcons';

const HeaderActions = ({ item }: { item: TargetProperties }) => {
	const [openActions, setOpenActions] = useState<boolean>(false);

	const toggleActionsHandler = (event: MouseEvent<SVGSVGElement>) => {
		event.stopPropagation();
		setOpenActions(!openActions);
	};

	const closeActionsHandler = () => setOpenActions(false);

	return (
		<div className="skillAreaActions" onMouseLeave={closeActionsHandler}>
			<div className="icon" style={{ width: '38px', height: '38px' }}>
				<InfoSvg onClick={toggleActionsHandler} />
				<div style={{ display: openActions ? 'flex' : 'none' }} className="adminActions">
					{item.status.id !== 1 && <OpenTarget target={item} />}
					<Copy id={item.id} programId={item.programId} />
					<Move id={item.id} programId={item.programId} />
					{item.status.id !== 2 && <MasterOut item={item} />}
					<Hold target={item} />
					{item.type.id === TargetTypes.TA && <EditSteps id={item.id} programId={item.programId} />}
					<Delete id={item.id} programId={item.programId} />
				</div>
			</div>
		</div>
	);
};

const Actions = ({ item }: { item: TargetProperties }) => (
	<div className="actions marginBottom16 marginTop16">
		<div className="targetNameDetails">
			<Text title={item.name} type="h6" fontWeight="semiBold" className="targetName" />
			<div>
				<Badge
					label={item.status.name.split(/(?=[A-Z])/).join(' ')}
					sizeType="sm"
					type={targetStatusType[item.status.name] as BadgeTypes}
				/>
			</div>
		</div>
		<div className="targetActionsWrapper">
			<GraphsTarget isIcon={false} targetId={item.id} targetName={item.name} type={item.type.id} />
			<Edit item={item} programId={item.programId} />
			<HeaderActions item={item} />
		</div>
	</div>
);

export default Actions;
